import { render, staticRenderFns } from "./Treeselect5.vue?vue&type=template&id=3c405e1d"
import script from "./Treeselect5.vue?vue&type=script&lang=js"
export * from "./Treeselect5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports